import { render } from "./MixedChartsPage.vue?vue&type=template&id=34aef9b0&ts=true"
import script from "./MixedChartsPage.vue?vue&type=script&lang=ts"
export * from "./MixedChartsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__